/*! *********************************************************************
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { useReducer, useCallback, useEffect } from 'react';
import { useDataProvider } from 'react-admin';

const initialState = {
  loading: false,
  categories: [],
};

function reducer(state, { type, payload }) {
  switch (type) {
    case 'init':
      return initialState;
    case 'loading':
      return {
        ...state,
        loading: true,
        categories: [],
      };

    case 'setCategories':
      return {
        ...state,
        loading: false,
        categories: payload.categories,
      };

    default:
      throw new Error('Unknown action type for AssetCategories');
  }
}

export default function useFetchCategories(assettype) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const dataProvider = useDataProvider();

  const fetchCategories = useCallback(
    async (assettype) => {
      if (!assettype || assettype === '') {
        dispatch({ type: 'init' });
        return;
      }
      dispatch({ type: 'loading' });
      const res = await dataProvider.getList('categories', {
        filter: { type: assettype },
      });
      dispatch({ type: 'setCategories', payload: { categories: res.data } });
    },
    [dataProvider]
  );

  useEffect(() => {
    fetchCategories(assettype);
  }, [assettype, fetchCategories]);

  return state;
}
